import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import LoginEmail from "./LoginEmail";
import CheckPassword from "./CheckPassword";
import PasswordResetSent from "./PasswordResetSent";
import VerifyEmailForm from "./VerifyEmailForm";
import VerifyEmailInfo from "./VerifyEmailInfo";
import NotificationsPopup from "../common/NotificationsPopup";
import ServerError from "../common/ServerError";
import LoginFooter from "./LoginFooter";
import LoginHeader from "./LoginHeader";
import AnnouncementCarousel from "./AnnouncementCarousel";
import { getAllVirtualProducts } from "../../actions/ProductActions";
import { getBanners } from "../../actions/BannersActions";
import ProductAvailabilityInfo from "./ProductAvailabilityInfo";
import { getProductAvailabilityInfo } from "../../configurations/ProductAvailabilityConfiguration";
import AvailabilityBanner from "./AvailabilityBanner";
import Banner from "@p1s/p1s-common-react/entities/Banner";
import MaintenanceBanner from "newApp/components/EmailLogin/MaintenanceBanner";

export class LoginEmailPage extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.getAllVirtualProducts();
        this.props.getBanners();
    }

    getMaintenanceBanner = (showProductAvailabilityBanner) => {
        if (showProductAvailabilityBanner)
            return <AvailabilityBanner/>;

        return <MaintenanceBanner banner={this.props.maintenanceBanner}/>;
    }

    render() {
        const redirectLocation = this.props.redirectLocation;
        if (redirectLocation) {
            window.location = redirectLocation;
        }

        const serverError = this.props.serverError;
        const hasServerError = serverError && serverError.length > 0;
        let productAvailabilityInfos = [];
        if (this.props.virtualProducts && this.props.virtualProducts.length > 0){
            productAvailabilityInfos = getProductAvailabilityInfo(this.props.virtualProducts);
        }
        const showProductAvailabilityBanner = productAvailabilityInfos.some(x => !x.isAvailable);

        return (
            <div>
                {this.getMaintenanceBanner(showProductAvailabilityBanner)}
                <LoginHeader/>
                <NotificationsPopup/>
                <div className="row signIn-row">
                    <div className="signIn-container">
                        <div className="col-xs-12 col-sm-6 left">
                            <div className="slides">
                                <LoginEmail/>
                                <CheckPassword/>
                                <VerifyEmailForm/>
                                <VerifyEmailInfo/>
                                <PasswordResetSent/>
                            </div>
                            <ServerError
                                errorSummary={"Login Failed"}
                                serverError={serverError}
                                isVisible={hasServerError}/>
                        </div>
                        <div className="col-xs-12 col-sm-6 right">
                            {showProductAvailabilityBanner ?
                                <ProductAvailabilityInfo productAvailabilityViews={productAvailabilityInfos}/> :
                                <AnnouncementCarousel announcements={this.props.announcements}/>}
                        </div>
                    </div>
                </div>
                <LoginFooter/>
            </div>
        );
    }
}

LoginEmailPage.propTypes = {
    serverError: PropTypes.string,
    carouselContent: PropTypes.any,
    getProductAvailabilityInfos: PropTypes.func,
    getBanners: PropTypes.func,
    maintenanceBanner: PropTypes.instanceOf(Banner),
    announcements: PropTypes.arrayOf(PropTypes.instanceOf(Banner))
};

const mapStateToProps = state => ({
    redirectLocation: state.loginState.redirectLocation,
    serverError: state.loginState.emailLoginFailure,
    virtualProducts: state.productState.virtualProducts,
    maintenanceBanner: state.bannersState.maintenanceBanner,
    announcements: state.bannersState.announcements
});

const mapDispatchToProps = (dispatch) => {
    return ({
        getAllVirtualProducts: () => dispatch(getAllVirtualProducts()),
        getBanners: () => dispatch(getBanners())
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginEmailPage);
